import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.config.productionTip = false

import axios from 'axios';
Vue.prototype.$axios = axios;

import qs from 'qs';
Vue.prototype.$qs = qs;

import async from 'async';
Vue.prototype.async = async;

import {
    Picker,
    Loadmore
} from 'mint-ui'
import 'mint-ui/lib/picker/style.css'
import 'mint-ui/lib/loadmore/style.css'
//      上拉加载
Vue.component(Loadmore.name, Loadmore);
// 饿了么手机ui picker
Vue.component(Picker.name, Picker);

// import 'lib-flexible'

// // 加入百度统计
// var _hmt = _hmt || [];
// window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
// (function () {
//     var hm = document.createElement("script");
//     //    hm.src = "https://hm.baidu.com/hm.js?"+ 百度站点id;
//     hm.src = "https://hm.baidu.com/hm.js?5912a711eaeaee7e0131d6ee88ef7889";
//     var s = document.getElementsByTagName("script")[0];
//     s.parentNode.insertBefore(hm, s);
// })();
router.beforeEach((to, from, next) => {
    if (to.path) {
        _hmt.push(['_trackPageview', '/#' + to.path])
        console.log("加入百度统计")
    }
    next()
})


new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')